<div class="card pt-0 mb-5">
    <div class="card-header">
        <h4>Charge Back Report</h4>
      </div>
</div>
<div class="row" style="min-height: 300px">
    <div class="col-12 col-xl-12 grid-margin stretch-card ag-theme-alpine">
      <ag-grid-angular [enableCellTextSelection]=true  (filterModified)="onFilterModified($event)"
        (filterOpened)="onFilterOpened($event)" (gridReady)="onGridReady($event)" (rowClicked)="onRowClicked($event)"
        (rowDoubleClicked)="onRowDoubleClicked($event)" [columnDefs]="tableSelectedColumn" [defaultColDef]="defaultColDef"
        [paginationPageSize]="pageSize" [pagination]="true" [rowData]="rowData" [rowModelType]=""
        [rowSelection]="'single'" [suppressPaginationPanel]="true" class="ag-theme-alpine"
        style="width: 100%; height: auto;">
      </ag-grid-angular>
    </div>
  </div>
  <div class="row bg-white p-2 mt-0">
  <div class="col-md-4">
    <select (change)="onPageSizeChanges($event)" [(ngModel)]="pageSize"
      class="form-select d-flex justify-content-end col-4" name="pageSize" style="width: auto">
      <option [ngValue]="10">10</option>
      <option [ngValue]="20">20</option>
      <option [ngValue]="30">30</option>
    </select>
  </div>
  <div class="col-md-8">
    <ngb-pagination (pageChange)="onPaginationChange($event)" [(page)]="currentPage" [boundaryLinks]="true"
      [collectionSize]="collectionSize" [maxSize]="5" [pageSize]="pageSize" [rotate]="true"
      class="d-flex justify-content-end col-8 align-right">
    </ngb-pagination>
  </div>
  </div>